// src/pages/CreateVehicleForm.jsx
import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, InputNumber, message } from "antd";
import { createVehicle } from "../api/vehicleApi";
import { getBrands } from "../api/brandApi";

const { Option } = Select;

const CreateVehicleForm = ({ onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await getBrands();
        setBrands(response.data);
      } catch (error) {
        console.error("Error fetching brands:", error);
        message.error("Error al cargar las marcas");
      }
    };
    fetchBrands();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await createVehicle(values);
      message.success("Vehículo creado exitosamente");
      onSuccess();
    } catch (error) {
      console.error("Error al crear el vehículo:", error);
      message.error("Error al crear el vehículo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#2a2a2a",
        color: "#ccc",
        padding: "1rem",
        borderRadius: "8px",
        border: "1px solid #444",
      }}
    >
      <h3 style={{ color: "#fff" }}>Crear Vehículo</h3>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label={<span style={{ color: "#ccc" }}>Placa</span>}
          name="plate"
          rules={[{ required: true, message: "Ingresa la placa" }]}
        >
          <Input
            placeholder="Ej: ABC123"
            style={{ background: "#1f1f1f", color: "#ccc" }}
          />
        </Form.Item>

        <Form.Item
          label={<span style={{ color: "#ccc" }}>Año</span>}
          name="year"
          rules={[{ required: true, message: "Ingresa el año" }]}
        >
          <InputNumber
            style={{ width: "100%", background: "#1f1f1f", color: "#ccc" }}
            placeholder="Ej: 2020"
          />
        </Form.Item>

        <Form.Item
          label={<span style={{ color: "#ccc" }}>VIN</span>}
          name="vin"
          rules={[{ required: true, message: "Ingresa el VIN" }]}
        >
          <Input
            placeholder="Ej: 1HGCM82633A004352"
            style={{ background: "#1f1f1f", color: "#ccc" }}
          />
        </Form.Item>

        <Form.Item
          label={<span style={{ color: "#ccc" }}>Marca</span>}
          name="brandId"
          rules={[{ required: true, message: "Selecciona la marca" }]}
        >
          <Select
            placeholder="Selecciona la marca"
            style={{ background: "#1f1f1f", color: "#ccc" }}
            dropdownStyle={{ background: "#2a2a2a" }}
          >
            {brands.map((brand) => (
              <Option key={brand.id} value={brand.id}>
                {brand.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Crear Vehículo
          </Button>
          <Button onClick={onCancel} style={{ marginLeft: 8 }}>
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateVehicleForm;
